
import React, { useEffect, useRef, useState } from "react";
import { useImageInputContext } from "../../../../ImageInputContext";
import {
  StyledAddMoreThumbnail,
  StyledImageThumbnail,
  StyledPlaceholderThumbnail,
  StyledSliderWrapper
} from "./styled";
import { ImageDisplayInMask } from "../../../../derivedComps/ImageDisplayInMask";

import { SkeletonLoader, icons, makeArrayFromLength, useScreenWidth, colors } from "oolib";
import { FileUploadShell } from "oolib/dist/components/FileUploadWrapper/comps/FileUploadShell" // TODO update export from oolib
const { Plus } = icons;

export const GalleryThumbnails = ({
  
  activeIdx,
  setActiveIdx,
  
}) => {
  const { value, isLoading, noOfImagesUploading, readOnly, invert, aspectRatio, handleUpload, onChange, id } = useImageInputContext();
  

  const [placeholderThumbsToRender, setPlaceholderThumbsToRender] = useState(0);
  const totThumbsSpaceRef = useRef(null)
  const addMoreThumbnailRef = useRef(null)

  const screenWidth = useScreenWidth()
  useEffect(() => {
    if(!readOnly){
      const {
        offsetWidth : thumbnailWidth
      } = addMoreThumbnailRef.current;
      
      const totAvailableSpace = totThumbsSpaceRef.current.offsetWidth - thumbnailWidth - 10;
      
      const gap = 10;
      const noOfThumbsWillFit = Math.floor(totAvailableSpace/(thumbnailWidth+gap))
      setPlaceholderThumbsToRender(noOfThumbsWillFit)
    }
    
  },[screenWidth])
  
  
  /**
   * create array of thumbnails to render. 
   * this is made up of 2 things:
   * 1 : the value array which holds the images data 
   * PLUS 2 : the noOfImagesUploading that will render skeleton loaders for images currently loading
   */
  const imageThumbnailsData = [
    ...(makeArrayFromLength(noOfImagesUploading).map(d => undefined)),
    ...(value || [])
  ]


  return (
    <div ref={totThumbsSpaceRef} style={{display: 'flex', gap: '1rem'}}>
      {!readOnly && (
        <StyledAddMoreThumbnail ref={addMoreThumbnailRef} disabled={isLoading} noBorder invert={invert}>
          
            <FileUploadShell 
              disabled={isLoading} 
              multiple={true} 
              mediaType={'image'} 
              handleUpload={handleUpload} 
              onChange={onChange} 
              value={value} 
              id={id}>
              <div
                style={{
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <Plus
                  size={24}
                  weight="bold"
                  color={invert ? colors.greyColor100 : colors.white}
                />
              </div>
            </FileUploadShell>
          
        </StyledAddMoreThumbnail>
      )}
      <StyledSliderWrapper>

      {imageThumbnailsData.map((v, idx) => {
          return (
            <StyledImageThumbnail
              key={v?.publicUrl || idx}
              onClick={() => setActiveIdx(idx)}
              isActive={activeIdx === idx}
              invert={invert}
            >
            { v 
              ? <ImageDisplayInMask
                  maskAspectRatio={'1'}
                  id={'thumb'+idx}
                  invert={invert}
                  disableImageBorder={true} 
                  defaultImageSpread='contain'
                  value={[v]} 
                  aspectRatio={aspectRatio} 
                  />
              : <SkeletonLoader style={{width: '100%', height: '100%'}}/>
            }
            </StyledImageThumbnail>
          );
        })}

      {(!value || value.length === 0) &&
        makeArrayFromLength(placeholderThumbsToRender).map(
          (order) => {
            return (
              <StyledPlaceholderThumbnail
                key={"blank thumbnail" + order}
                isBlank
              />
            );
          }
        )}
    </StyledSliderWrapper>
    </div>
    
  );
};
